import Axios from "axios";
import { cmc3_api_gateway } from "../config/config"
import { loading } from "../helpers/default";
import { error_handle } from "../helpers/error";


class ExchangePNLModel{
    constructor(){
        this.url = cmc3_api_gateway
    }

    chart_pnl(data={}){
        loading(true, 'Loading...')
        return Axios.request({
            url: this.url + '/exchange/chart/pnl',
            method: "POST",
            data:{...data},
            withCredentials: true, 
        })

            .then(response => {
                loading(false, 'Loading...')
                response = response['data'];
                if(response['result']) return response
                error_handle(response)

            })
            .catch(error => {
                error_handle(error)
            })
    }

    
    table_winrate(data={}){
        loading(true, 'Loading...')
        return Axios.request({
            url: this.url + '/exchange/table/winate',
            method: "POST",
            data:{...data},
            withCredentials: true, 
        })

            .then(response => {
                loading(false, 'Loading...')
                response = response['data'];
                if(response['result']) return response
                error_handle(response)

            })
            .catch(error => {
                error_handle(error)
            })
    }

    campaign_mapping(data={}){
        loading(true, 'Loading...')
        return Axios.request({
            url: this.url + '/exchange/campaign/mapping',
            method: "POST",
            data:{...data},
            withCredentials: true, 
        })

            .then(response => {
                loading(false, 'Loading...')
                response = response['data'];
                if(response['result']) return response
                error_handle(response)

            })
            .catch(error => {
                error_handle(error)
            })
    }

   
    


}


export default ExchangePNLModel